export const GIOTTO_V2_URL =
  'https://giotto.onoranzefunebricloud.com/?ref=beta';

/**
 * Redirects the current window to Giotto 2.0.
 * Uses `location.replace` to avoid keeping the old app in history.
 */
export function redirectToGiottoV2() {
  try {
    window.location.replace(GIOTTO_V2_URL);
  } catch (e) {
    // As a fallback, assign directly
    window.location.href = GIOTTO_V2_URL;
  }
}
